<template>
    <div class="main-container">
        <h2 class="main-title bottom-row">Change layout management</h2>
        <v-row>
            <v-col cols="6">
                <label class="form__label">Theme name</label>
                <input type="text" class="form__input" v-model="data.name" name="theme name" v-input-trim
            /></v-col>
        </v-row>
        <v-row
            ><v-col><h3>Custom layout</h3></v-col></v-row
        >
        <v-row>
            <v-col cols="4"><v-switch v-model="data.layout.navbar" label="Mobile navbar" class="my-0"></v-switch></v-col>
            <v-col><div>default value is true</div></v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-switch v-model="data.layout.title" label="Title above promo banner" class="my-0"></v-switch
            ></v-col>
            <v-col><div>default value is true</div></v-col>
        </v-row>
        <v-row>
            <v-btn @click="save()" color="success" class="my-5">Save changes</v-btn>
        </v-row>
    </div>
</template>

<script>
import config from '../../../config';

export default {
    components: {},
    name: 'ChangeLayoutForm',
    props: ['selectedArena'],
    data() {
        return {
            data: this.selectedArena.config.theme.theming || { name: '', layout: {} }
        };
    },
    watch: {
        'selectedArena.config.theme.theming': function() {
            if (this.selectedArena.config.theme.theming) {
                this.data = this.selectedArena.config.theme.theming;
            }
        }
    },
    methods: {
        save: function() {
            this.$http
                .post(`${config.apiUrl}/arena/theming`, this.data, {
                    params: { domain: this.selectedArena.domain }
                })
                .then(
                    () => {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Success!',
                            text: 'Data was saved successfully'
                        });
                    },
                    (error) => {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Error!',
                            text: 'Something went wrong, please contact WebPortals.'
                        });
                        console.log(error);
                    }
                );
        }
    }
};
</script>
